"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgTrendDown01 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M2.707 6.293a1 1 0 0 0-1.414 1.414l4.891 4.891c.179.179.352.353.512.488.174.148.396.308.686.402a2 2 0 0 0 1.236 0c.29-.094.512-.254.686-.402a9.19 9.19 0 0 0 .512-.488l2.76-2.76c.21-.21.325-.323.414-.4L13 9.43l.01.009c.09.076.205.19.414.4L19.586 16H15a1 1 0 1 0 0 2h7a1 1 0 0 0 1-1v-7a1 1 0 1 0-2 0v4.586l-6.184-6.184a9.171 9.171 0 0 0-.511-.488 2.022 2.022 0 0 0-.687-.402 2 2 0 0 0-1.236 0c-.29.094-.512.254-.687.402-.159.135-.332.31-.51.488l-2.76 2.76c-.21.21-.326.323-.415.4L8 11.57l-.01-.009a8.177 8.177 0 0 1-.414-.4L2.707 6.293Z", fill: "currentColor" }) }))); };
exports.default = SvgTrendDown01;
